import request from '../network';

const prefix = 'lz-member-server';

export const getMemberListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberShopInfo`,
    method: 'POST',
    data,
  });
};

export const getMemberGradeListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberGradeList`,
    method: 'POST',
    data,
  });
};

export const getMemberStatusListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberStatusList`,
    method: 'GET',
    params: data,
  });
};

export const getMemberInfoApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberInfo`,
    method: 'POST',
    data,
  });
};

export const getMemberEventTypesApi = () => {
  return request({
    url: `${prefix}/royalcanin/admin/member/getEventTypes`,
    method: 'GET',
  });
};

export const getMemberJourneyApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberJourneyRecord`,
    method: 'POST',
    data,
  });
};

export const getPetInfoApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/getPetInfo`,
    method: 'POST',
    data,
  });
};

export const getOrderInfoApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/getOrderInfo`,
    method: 'POST',
    data,
  });
};

export const getMemberCardInfoApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/memberCarInfo`,
    method: 'POST',
    data,
  });
};

export const getGradeChangeListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/gradeChangeList`,
    method: 'POST',
    data,
  });
};

export const getPointChangeListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/pointChangeList`,
    method: 'POST',
    data,
  });
};

export const getGrowthValueChangeListApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/growthValueChangeList`,
    method: 'POST',
    data,
  });
};

export const changeGradeApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/changeGrade`,
    method: 'POST',
    data,
  });
};

export const changePointApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/changePoint`,
    method: 'POST',
    data,
  });
};

export const changeGrowthValueApi = (data: Record<string, any>) => {
  return request({
    url: `${prefix}/royalcanin/admin/member/changeGrowthValue`,
    method: 'POST',
    data,
  });
};

export const getBenefitsListApi = (
  shopId: number | string,
  data: { benefitsType?: string } = { benefitsType: 'ALL' },
) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/list`,
    method: 'POST',
    data,
  });
};

export const viewBenefitApi = (shopId: number | string, data: { benefitsId: number | string }) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/view`,
    method: 'POST',
    data,
  });
};

export const saveOrUpdateBenefitApi = (shopId: number | string, data: any) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/saveOrUpdate`,
    method: 'POST',
    data,
  });
};

export const switchBenefitApi = (
  shopId: number | string,
  data: { switchValue: number; switchType: string; benefitsId: number | string },
) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/switchTurn`,
    method: 'POST',
    data,
  });
};

export const deleteBenefitApi = (shopId: number | string, benefitsId: number | string) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/deleteById`,
    method: 'POST',
    data: { benefitsId },
  });
};

export const sortBenefitApi = (
  shopId: number | string,
  data: { sortType: 'UP' | 'DOWN'; benefitsId: number | string },
) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/sort`,
    method: 'POST',
    data,
  });
};

export const getBenefitSendRecordPageApi = (shopId: number | string, data: any) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/sendRecord/page`,
    method: 'POST',
    data,
  });
};

export const getBenefitSendRecordNamesApi = (shopId: number | string) => {
  return request({
    url: `/member/royalcanin/admin/benefits/${shopId}/sendRecord/benefitsNames`,
    method: 'GET',
  });
};

export const checkGrowUpBenefitApi = (shopId: number | string, data: { shopUserId: string }) => {
  return request({
    url: `/member/royalcanin/admin/benefits/growUp/${shopId}/checkGrowUpBenefit`,
    method: 'POST',
    data,
  });
};

export const queryGrowUpPetListApi = (shopId: number | string, data: { shopUserId: string }) => {
  return request({
    url: `/member/royalcanin/admin/benefits/growUp/${shopId}/queryPetList`,
    method: 'POST',
    data,
  });
};

export const sendGrowUpBenefitsApi = (
  shopId: number | string,
  data: {
    growUpType: 'ADULT' | 'OLD';
    oneId: string;
    petOneId: string;
    sendType: 'POINT' | 'THIRD_PLAT';
    sendValue: string;
    shopId: string;
    shopUserId?: string;
  },
) => {
  return request({
    url: `/member/royalcanin/admin/benefits/growUp/${shopId}/sendGrowUpBenefits`,
    method: 'POST',
    data,
  });
};

// 广告相关
export const getAdPositionsApi = () => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/positions`,
    method: 'GET',
  });
};

export const getAdBannerListApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/list`,
    method: 'POST',
    data,
  });
};

export const addAdBannerApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/add`,
    method: 'POST',
    data,
  });
};

export const getAdBannerDetailApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/${id}`,
    method: 'GET',
  });
};

export const editAdBannerApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/edit`,
    method: 'POST',
    data,
  });
};

export const deleteAdBannerApi = (id: number | string) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/${id}`,
    method: 'POST',
  });
};

export const moveUpAdBannerApi = (id: number | string, data?: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/moveUp/${id}`,
    method: 'POST',
    data,
  });
};

export const moveDownAdBannerApi = (id: number | string, data?: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/adBanner/moveDown/${id}`,
    method: 'POST',
    data,
  });
};
